var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40.392,
    height: 40.392,
    viewBox: "0 0 40.392 40.392",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.277,
    y1: 0.156,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe0d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#787cfe"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M-21.052-52.429-36.38-46.536l.181-2.311a1.266,1.266,0,0,0-1.893-1.191l-13.916,8.063A16.008,16.008,0,0,0-60-28.123,16.016,16.016,0,0,0-43.985-12.108,16.02,16.02,0,0,0-30.124-20.1l8.055-13.916a1.263,1.263,0,0,0-1.191-1.893l-2.311.181,5.893-15.328a1.04,1.04,0,0,0,.071-.379A1.061,1.061,0,0,0-20.673-52.5,1.01,1.01,0,0,0-21.052-52.429Zm-23.8,15.076A10.1,10.1,0,0,1-36.108-32.3a10.1,10.1,0,0,1,0,10.1,10.1,10.1,0,0,1-8.745,5.049A10.1,10.1,0,0,1-53.6-22.206a10.1,10.1,0,0,1,0-10.1A10.1,10.1,0,0,1-44.853-37.353Zm0,7.573A2.524,2.524,0,0,0-47.378-32.3,2.524,2.524,0,0,0-49.9-29.78a2.524,2.524,0,0,0,2.524,2.524A2.524,2.524,0,0,0-44.853-29.78Zm1.262,7.573a1.262,1.262,0,0,0,1.262-1.262,1.262,1.262,0,0,0-1.262-1.262,1.262,1.262,0,0,0-1.262,1.262A1.262,1.262,0,0,0-43.591-22.206Z",
    transform: "translate(60 52.5)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.dd0a889fa451458065d7e77100f203e4.svg";
export { ForwardRef as ReactComponent };